<ws-select
	[options]="timezoneOptions"
	[(result)]="result"
	(resultChange)="onResultChange($event)"
	display="display"
	value="value"
	[label]="label"
	[placeholder]="placeholder"
	[disabled]="disabled"
	[required]="required"
	[readonly]="readonly"
	[validationConstraints]="validationConstraints"
	[errors]="errors"
	[model]="model"
	[property]="property"
></ws-select>
